<template>
  <div class="drugData">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="80px">
      <el-form-item label="" label-width="40px">
        <el-radio-group v-model="searchForm.status" @change="init">
          <el-radio-button label="0">未分配</el-radio-button>
          <el-radio-button label="1">已分配</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="name"
            label="药房名称">
        </el-table-column>
        <el-table-column
            prop="code"
            label="药房编码">
        </el-table-column>
        <el-table-column
            prop="address"
            label="药房地址">
        </el-table-column>
        <el-table-column
            prop="area"
            label="地区">
        </el-table-column>
        <el-table-column
            prop="address"
            fixed="right"
            min-width="150"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button @click="addItem(scope.row)" type="text" size="small">分配现有数据库</el-button>
            <el-button @click="addNewItem(scope.row)" type="text" size="small">分配新数据库</el-button>
            <el-button @click="moreItem(scope.row)" type="text" size="small">查看数据库</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="margin-top: 20px">
      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'
                  @handleCurrentChange='handleCurrentChange'></Pagination>
    </div>
    <el-dialog
        :title="modelTitle"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        @close="close"
        width="30%">
      <el-form :model="existingForm" :rules="rules" ref="existingForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="数据库名称">
          <dataInput  @fieldId="existingId($event,'instanceId')" :defaultName="newData.dataBaseName" :initName="existingForm.dataBaseName" style="width: 220px"
                     :url="'api/DataBaseManage'"></dataInput>
        </el-form-item>
        <el-form-item label="生效时间">
          <el-date-picker
              style="width: 100%"
              v-model="existingForm.initDate"
              type="date"
              placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="失效时间">
          <el-date-picker
              v-model="existingForm.expireDate"
              type="year"
              placeholder="选择日期">
          </el-date-picker>
          /01/01
        </el-form-item>
        <el-form-item label="初始化">
          <el-radio-group v-model="existingForm.autoInitDataBase">
            <el-radio-button :label="true">是</el-radio-button>
            <el-radio-button :label="false">否</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="端口号">
          <el-input v-model="existingForm.port" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="existForm('existingForm')">确定</el-button>
          <el-button @click="close">取 消</el-button>
      </span>
    </el-dialog>
    <!--    新数据库-->
    <el-dialog
        :title="modelTitle"
        :close-on-click-modal="false"
        :visible.sync="newVisible"
        width="20%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="服务器IP">
          <el-select v-model="ruleForm.server" style="width: 100%" placeholder="请选择">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据库名称">
          <el-input v-model="ruleForm.dataBaseName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="用户名">
          <el-input v-model="ruleForm.userId" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="ruleForm.password" type="password" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="初始化">
          <el-radio-group v-model="ruleForm.autoInitDataBase">
            <el-radio-button :label="true">是</el-radio-button>
            <el-radio-button :label="false">否</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="端口号">
          <el-input v-model="ruleForm.port" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="失效时间">
          <el-date-picker
              style="width: 100%"
              v-model="ruleForm.expireDate"
              type="date"
              placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
          <el-button @click="newVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!--    查看数据库-->
    <el-dialog
        title="数据库详情"
        :close-on-click-modal="false"
        :visible.sync="moreDataVisible"
        width="50%">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="moreData"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="dataBaseName"
            label="数据库名称">
        </el-table-column>
        <el-table-column
            prop="server"
            label="IP地址">
        </el-table-column>
        <el-table-column
            prop="initDate"
            label="生效日期">
        </el-table-column>
        <el-table-column
            prop="expireDate"
            label="失效日期"
            align="center">
        </el-table-column>
        <el-table-column
            prop="autoInitDataBase"
            label="是否自动初始化"
            align="center">
          <template slot-scope="scope">
            {{scope.row.autoInitDataBase?'是':'否'}}
          </template>
        </el-table-column>
        <el-table-column
            prop="currentDataBase"
            label="当前数据库"
            align="center">
          <template slot-scope="scope">
            {{scope.row.currentDataBase?'是':'否'}}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import DicInput from "@/components/DicInput";
import dataInput from "@/components/dataInput";

export default {
  name: "drugData",
  data() {
    return {
      tableData: [],
      moreData: [],
      searchForm: {
        status:'0'
      },
      modelTitle: '绑定数据库',
      dialogVisible: false,
      newVisible: false,
      moreDataVisible: false,
      ruleForm: {
        server: '',
        dataBaseName: '',
        userId: '',
        password: '',
        autoInitDataBase: true,
        port: '',
        expireDate: null,
      },
      existingForm: {
        server: '',
        dataBaseName: '',
        instanceId:null,
        userId: '',
        password: '',
        autoInitDataBase: true,
        port: '',
        expireDate: null,
      },
      options: [],
      rules: {},
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
      areaId: '',
      newData: {
        dataBaseName:null
      },
    }
  },
  components: {
    //someComponent
    Pagination,
    DicInput,
    dataInput
  },
  methods: {
    //搜索
    search() {
      this.init()
    },
    clear() {
      this.searchForm = {
        status: '0',
      }
      this.init()
    },
    addItem(item) {
      this.modelTitle = '绑定数据库'
      if(this.newData.instanceId){
        this.existingForm = {
          pharmacyId:  this.newData.pharmacyId,
          dataBaseName: this.newData.dataBaseName,
          instanceId: this.newData.instanceId,
          pharmacyCode:  this.newData.pharmacyCode,
          initDate: null,
          expireDate: null,
          autoInitDataBase: true,
          currentDataBase: true,
          port: null
        }
      }else {
        this.existingForm = {
          pharmacyId: item.id,
          instanceId:null,
          pharmacyCode: item.code,
          initDate: null,
          expireDate: null,
          autoInitDataBase: true,
          currentDataBase: true,
          port: null
        }
      }
      this.dialogVisible = true
    },
    addNewItem(item) {
      this.modelTitle = '创建新数据库'
      let time = new Date().getFullYear()
      this.ruleForm = {
        server: '',
        userId: 'yh_administrator1',
        password: 'Yh88888888',
        dataBaseName: 'pharmacy_' + time + '_' + item.id,
        expireDate: null,
        pharmacyId: item.id,
        pharmacyCode: item.code,
        autoInitDataBase: true,
      }
      this.newVisible = true
    },
    // 查看数据库
    moreItem(item) {
      let data = {
        pharmacyId: item.id
      }
      this.axios
          .get("api/PharmacyDb/GetPharmacyDataBases", {params: data}).then(res => {
        this.moreData = res.list
        this.moreDataVisible = true
      })
    },
    existingId(item, name) { // 字典
      if (item.id) {
        this.existingForm[name] = item.id
        this.existingForm.dataBaseName = item.name
        this.existingForm.instanceName = item.name
      } else {
        this.existingForm[name] = ''
      }
    },
    close(){
      this.existingForm = {}
      this.newData = {}
      this.dialogVisible = false
    },
    ruleFormFieldId(item, name) { // 新增模块字典
      if (item.id) {
        if (name === 'factoryId') {
          this.ruleForm.factoryName = item.name
          this.ruleForm.factoryCode = item.code
          this.ruleForm.factoryId = item.id
        } else {
          this.ruleForm.drugTypeName = item.name
          this.ruleForm.drugTypeId = item.id
        }
      } else {
        this.ruleForm[name] = ''
      }
    },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm('数据库创建成功不可删除, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let data = {
              ...this.ruleForm,
              expireDate: this.ruleForm.expireDate
            }
            this.axios
                 .post("api/DataBaseManage?init=" + this.ruleForm.autoInitDataBase, data).then((res) => {
              this.newData={
                ...data,
                instanceId: res.data.id
              }
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.newVisible = false
              this.addItem()
              this.init()
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        } else {
          return false;
        }
      });
    },
    existForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            ...this.existingForm,
          }
          this.axios
               .post("api/PharmacyDb", data).then((res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.existingForm = {}
            this.newData = {}
            this.$refs[formName].resetFields();
            this.dialogVisible = false
            this.init()
          })
        } else {
          return false;
        }
      });
    },
    // list
    init() {
      let data = {
        ...this.searchForm,
        page: this.currPage,
        pageSize: this.pageSize,
      }
      this.axios
          .get("api/Pharmacy/GetPharmacyByDbStatus", {params: data})
          .then((res) => {
            this.tableData = res.list
            this.total = res.count
          })
    },
    serverList() {
      let data = {
        page: 1,
        pageSize: 1000,
      }
      this.axios
          .get("api/ServiceManage", {params: data})
          .then((res) => {
            this.options = res.list
            let obj = [];
            this.options.forEach(item => {
              obj.push({
                value: item.ip,
                label: item.name,
              })
            });
            this.options = obj;
          })
    }
  },
  mounted() {
    //
    this.init()
    this.serverList()
  }
}
</script>

<style lang="scss" scoped>
.drugData {

}
</style>